document.addEventListener("DOMContentLoaded", function() {
  // Image URLs to preload
  const imageUrls = {
    "tranquil-family": "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/whalecoll2_407c26a1-8aea-4dae-8093-a1eccc0a43bc.jpg?v=1674134974",
    "tranquil-turtle™-rechargeable": "https://cloudb.com/cdn/shop/files/DSC03253-Grande_42952d1a-dd0d-4071-b1ec-5d81f451fd76.webp?v=1706301897",
    "tranquil-turtle™": "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/turtelcollection.jpg?v=1673789702",
    "tranquil-penguin™": "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/9200-PG_4.jpg?v=1723879827",
    "tranquil-whale™": "https://cdn.shopify.com/s/files/1/0656/9292/6220/products/DSC03265-Moyenne_eaddc322-1aa7-403b-8d73-7df706fb993e.webp?v=1692972216",
    "stars-projectors": "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/starprojherader.jpg?v=1674139823",
    "twilight-turtle™": "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/7323-BL_lifestyle_14_-_Moyenne.jpg?v=1674848533",
    "twinkling-twilight-turtles": "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/twinklecoll.jpg?v=1673792654",
    "twilight-buddies": "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/7473-BB_23.jpg?v=1708102130",
    "twilight-ladybug": "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/lady.png?v=1708102032",
    "dream-buddies": "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/dreamcoll.jpg?v=1673792428",
    "on-the-go": "https://cdn.shopify.com/s/files/1/0656/9292/6220/collections/0cb1b3a3-a3ff-4d72-9d37-2d7fe89a4b4a._CR0_0_500_500_SX460.jpg?v=1673789440",
    "travel-sound-soothers": "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/Screenshot_2024-02-16_175408.png?v=1708102480",
    "sweet-dreamz™": "https://cloudb.com/cdn/shop/collections/sweet-dreamz_1524x.jpg?v=1673790677",
    "twinkles-to-go": "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/7451-PK3_lifestyle_14_square-1_e896fb1b-7c5d-4e3f-b9c3-fc945a9c6d79.jpg?v=1707401372",
    "sound-soothers": "https://cloudb.com/cdn/shop/collections/lionhome_1524x.jpg?v=1673771944",
    "lovelight™-buddies": "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/lovelight.png?v=1708710651",
    "cloudbox™": "https://cdn.shopify.com/s/files/1/0656/9292/6220/files/cloudbox-screen.png?v=1708711040",
    "shop-all": "https://cloudb.com/cdn/shop/files/menutopcb_1524x.jpg?v=1693901867"
  };

  // Preload images
  const preloadedImages = {};
  for (const key in imageUrls) {
    const img = new Image();
    img.src = imageUrls[key];
    preloadedImages[key] = img;
  }

  const testImage = document.getElementById("navigation-hovering-img");

  document.querySelectorAll("a[data-hover]").forEach(function(link) {
    link.addEventListener("mouseover", function() {
      const productHandle = this.getAttribute("data-hover");
      const image = preloadedImages[productHandle];
      if (image) {
        testImage.src = image.src;
      }
    });
  });
});
